import { render, staticRenderFns } from "./PreOrders.vue?vue&type=template&id=5e1640d2"
import script from "./PreOrders.vue?vue&type=script&lang=js"
export * from "./PreOrders.vue?vue&type=script&lang=js"
import style0 from "./PreOrders.vue?vue&type=style&index=0&id=5e1640d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports